<template>
  <div class="indicador-management mx-1" v-if="asyncDataStatus_ready">


    <v-container fluid class="indicador-edit" v-if="indicadores.length">
      <v-card tile>
        <v-card-title>
          <p>Selececione um indicador</p>
        </v-card-title>

        <v-card-text>
          <v-select
            v-model="indicadorSelecionado"
            label="Indicadores"
            :items="indicadores"
            item-text="titulo"
            item-value="id"
            outlined
            return-object
            @change="reouterPush"
          >
            <template v-slot:selection='{ item }'>
              {{ item.posicaoFormatada }} {{ item.titulo }}
            </template>
            <template v-slot:item="{ item }">
              {{ item.posicaoFormatada }} {{ item.titulo }}
            </template>
          </v-select>
        </v-card-text>
      </v-card>

      <v-col cols="12"></v-col>

      <v-tabs color="primary">
        <v-tabs-slider></v-tabs-slider>

        <v-tab :href="`#tab-info`" class="mr-5">
          <v-icon class="mr-3">mdi-book-information-variant</v-icon>
          Informações
        </v-tab>
        <v-tab class="mr-5" :href="`#tab-fontes`">
          <v-icon class="mr-3">mdi-clipboard-file</v-icon>
          Fontes de Verificação
        </v-tab>
        <v-tab class="mr-5" :href="`#tab-subindicadores`">
          <v-icon class="mr-3">mdi-flag</v-icon>
          Subindicadores
        </v-tab>

        <v-tab-item :value="'tab-info'">
          <v-card elevation="0" flat tile>
            <v-progress-linear color="teal darken-4" height="30" :value="indicadorSelecionado.porcentagemTotalAtingido" striped>
              <template v-slot:default="{ value }">
                <v-chip class="font-weight-bold" color="teal darken-2" text-color="white" small> {{ value ? value.toFixed(2): ''}}%</v-chip>
              </template>
            </v-progress-linear>

            <v-card-title>
              <p>{{ indicadorSelecionado.posicaoFormatada }} {{ indicadorSelecionado.titulo }}</p> 
            </v-card-title>
            <v-divider></v-divider>
              <v-card-text>

                <v-row>
                  <v-col cols="12" class="mb-n4">
                    <span class="font-weight-bold text-uppercase">Descrição:</span>
                    <p class="font-weight-light title ">
                      {{ indicadorSelecionado.descricao }}
                    </p>
                  </v-col>

                  <v-col cols="12">
                    <span class="font-weight-bold text-uppercase">Responsável por Lançamento de Fontes: </span>
                    <span class="font-weight-light title">{{ indicadorSelecionado.responsavel ? indicadorSelecionado.responsavel.nome : '' }}</span>
                  </v-col>

                  <v-col cols="6">
                    <span class="font-weight-bold text-uppercase">Ações:</span>
                    <p class="font-weight-light title">
                      {{ indicadorSelecionado.acoes ? indicadorSelecionado.acoes : ''}}
                    </p>
                  </v-col>

                  <v-col cols="6">
                    <span class="font-weight-bold text-uppercase">Recursos:</span>
                    <p class="font-weight-light title ">
                      {{ indicadorSelecionado.recursos ? indicadorSelecionado.recursos : '' }}
                    </p>
                  </v-col>                  

                  <v-col cols="6">
                    <span class="font-weight-bold text-uppercase">Criticidade:</span>
                    <p class="font-weight-light title">
                      {{ indicadorSelecionado.criticidade ? indicadorSelecionado.criticidade : ''}}
                    </p>
                  </v-col>
                  <v-col cols="6">
                    <span class="font-weight-bold text-uppercase">Descrição das Fontes de Verificação:</span>
                    <p class="font-weight-light title ">
                      {{ indicadorSelecionado.descricaoFonteVerificaao ? indicadorSelecionado.descricaoFonteVerificaao : ''}}
                    </p>
                  </v-col>

                  <v-col cols="12" class="mt-n4">
                    <span class="font-weight-bold text-uppercase">Formulários: </span>
                    <p class="font-weight-light title" v-if="indicadorSelecionado.listaPresenca">Lista de Presença (Presencial/Virtual)</p>
                    <p class="font-weight-light title" v-if="indicadorSelecionado.relatoriaReuniaoEncontro">Relatoria de Reunião Encontro</p>
                    <p class="font-weight-light title" v-if="indicadorSelecionado.planoOficinaIntercambioCaravana">Plano de Oficina Intercâmbio Caravana</p>
                    <p class="font-weight-light title" v-if="indicadorSelecionado.relatoriaOficinaIntercambioCaravana">Relatoria de Oficina Intercâmbio Caravana</p>
                    <p class="font-weight-light title" v-if="indicadorSelecionado.registroFotograficoModelado">Registro Fotográfico Modelado</p>	
                    <p class="font-weight-light title" v-if="indicadorSelecionado.informeReuniao">Informe de Reunião</p>	
                  </v-col>
                  <v-col cols="3">
                    <span class="font-weight-bold text-uppercase">Tipologia: </span>
                    <span class="font-weight-light  title">{{ indicadorSelecionado.tipologia }}</span>
                  </v-col>
                  <v-col cols="3">
                    <span class="font-weight-bold text-uppercase">Valor de Base: </span>
                    <span class="font-weight-light  title">{{indicadorSelecionado.valorDeBase}}</span>
                  </v-col>
                  <v-col cols="3">
                    <span class="font-weight-bold text-uppercase">Valor Esperado: </span>
                    <span class="font-weight-light   title">{{indicadorSelecionado.totalEsperado}}</span>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions class="pb-8 mx-2">
                <IndicadorEdita
                  v-if="isPermissaoIndicador && indicadorSelecionado.id"                
                  titulo="Editar Indicador"
                  :logicaIntervencao="logicaIntervencao"
                  :indicador="indicadorSelecionado"
                ></IndicadorEdita>
                <v-btn v-if="isPermissaoIndicador" @click="excluir" color="error text-center" small class="ml-2">Excluir</v-btn>
                <Confirm ref="confirm"></Confirm>
              </v-card-actions>
          </v-card>
        </v-tab-item>

        <v-tab-item :value="'tab-fontes'">
          <FonteVerificacao :isPermissao="isPermissaoLancamento" v-if="indicadorSelecionado.id" :indicadorSelecionado="indicadorSelecionado"></FonteVerificacao>
        </v-tab-item>

        <v-tab-item :value="'tab-subindicadores'">

        

          <v-card elevation="0" flat tile>
            <v-card-title>
              <p>Subindicadores</p>
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="subindicadorId"
                    :items="indicadorItensAutocomplete"
                    dense
                    filled
                    label="Selecione um indicador para adicionar"
                    item-text="tituloFormatado"
                    item-value="id"            
                  ></v-autocomplete>
                  <v-btn class="mt-auto" color="primary" @click="adicionarSubindicador">Adicionar subindicador</v-btn>
                </v-col>
              </v-row>
            </v-card-text>


            <v-card-text>
              <v-data-table
                class="fonte-table"
                :headers="headers_subindicadores"
                :items="subindicadores"
                :search="search"
                no-data-text="Não há subindicadores disponíveis"
                no-results-text="Nenhum subindicador encontrado"
                sort-by="ordem"
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td>
                      <router-link class="indicador-link primaryConst--text" :to="{ name: routeNameIndicador, params: { logicaIntervencaoId: item.logicaIntervencao.id, indicadorId: item.id }}">
                        <strong>{{ item.posicaoFormatada }} {{ item.titulo }}</strong>
                      </router-link>
                    </td>
                    <td>
                      <span>{{
                        item.responsavel
                          ? item.responsavel.nome
                          : "Aguardando definição"
                      }}</span>
                    </td>
                    <td>
                      <span>{{ item.tipologia }}</span>
                    </td>
                    <td>
                      <v-chip class="ma-2 pa-4">{{ item.valorDeBase }}{{ item.tipologia === "PROGRESSIVA" ? "%" : "" }}</v-chip>
                    </td>
                    <td>
                      <v-chip color="primary" class="ma-2 pa-4">{{ item.totalEsperado }}{{ item.tipologia === "PROGRESSIVA" ? "%" : "" }}</v-chip>
                    </td>
                    <td>
                      <v-chip color="warning" class="ma-2 pa-4">{{ item.totalAtingido }}{{ item.tipologia === "PROGRESSIVA" ? "%" : "" }}</v-chip>
                    </td>
                    <td>
                      <v-chip color="success" class="ma-2 pa-4">{{ item.porcentagemTotalAtingido.toFixed(2) }}%</v-chip>
                    </td>
                    <td>
                      <v-btn small fab class="mt-auto" color="secondary" @click="removerSubindicador(item)"><v-icon dark>mdi-delete</v-icon></v-btn>
                    </td>
                  </tr>
                </template>
                
              </v-data-table>
            </v-card-text>
          </v-card>



        </v-tab-item>
      </v-tabs>
    </v-container>
  </div>
</template>

<script>
import IndicadorEdita from "@/pages/Projeto/pages/Indicador/Edita/IndicadorEdita";
import FonteVerificacao from "@/pages/Projeto/components/FonteVerificacao/FonteVerificacao";
import Confirm from "@/components/Dialog/Confirm";

import asyncDataStatus from "@/mixins/asyncDataStatus";
import { mapActions } from "vuex";

export default {
  name: "IndicadorManagement",

  components: {
    IndicadorEdita,
    FonteVerificacao,
    Confirm
  },

  props: {
    logicaIntervencao: {
      require: false,
    },
  },
  mixins: [asyncDataStatus],

  data() {
    return {
      search: "",
      subindicadorId: null,
      dialog: false,
      headersl: [
        { text: "Mês de lançamento", align: "start", value: "mes"},
        { text: "Lançado por", value: "lancadoPor.nome" },
        { text: "Status", value: "status" },
        { text: "Monitorado por", value: "monitoradoPor.nome" },
        { text: "Progresso gdfgd", value: "progresso" },
        { text: "Ações" },
      ],
      headers_subindicadores: [
        {
          text: "Indicador",
          align: "start",
          value: "tituloFormatado",
          width: "40%",
        },
        { text: "Responsável por Lançamento", value: "responsavel.nome", width: "20%" },
        { text: "Tipologia", value: "tipologia" },
        { text: "Valor de Base", value: "valorDeBase" },
        { text: "Total Esperado", value: "totalEsperado" },
        { text: "Valor Atual", value: "totalAtingido" },
        { text: "Total Atingido(%)", value: "totalAtingido" },
        { text: "", value: "action" },

      ],

      indicadorSelecionado: {}//this.$store.getters["indicador/byId"](parseInt(this.$route.params.indicadorId))
    };
  },
  computed: {
    subindicadores() {
      return this.$store.getters["indicador/subindicadores"](parseInt(this.$route.params.indicadorId));
    },

    indicadorItensAutocomplete() {
      return this.$store.getters["indicador/indicadorItensAutocomplete"](parseInt(this.$route.params.projetoId));
    },

    usuario() {
      return this.$store.getters["usuario/getUser"]
    }, 

    isPermissaoIndicador() {
      //candEdit
      if(this.$store.getters["auth/isAdministrador"]) {
        return true
      }
      
      const usuarioId = this.$store.getters["usuario/getUsuarioAutenticado"].id;      

      var payload = {
        'permission': ['PERMISSION_INDICADOR_EDIT'],
        'projetoId': parseInt(this.$route.params.projetoId),
        'usuarioId': usuarioId
      }
      
      return this.$store.getters["projeto/hasPermission"](payload);
    },
    
    isPermissaoLancamento() {
      //candEdit
      if(this.$store.getters["auth/isAdministrador"]) {
        return true
      }
      const usuarioId = this.$store.getters["usuario/getUsuarioAutenticado"].id;      
      
      if(this.indicadorSelecionado.responsavel.id === usuarioId) {
        return true
      }
      var payload = {
        'permission': ['PERMISSION_INDICADOR_EDIT', 'PERMISSION_LANCAMENTO_FONTE_EDIT'],
        'projetoId': parseInt(this.$route.params.projetoId),
        'usuarioId': usuarioId
      }
      
      return this.$store.getters["projeto/hasPermission"](payload);
    },
    
    indicadores() {
      return this.$store.getters["indicador/byLogicaIntervencaoId"](parseInt(this.$route.params.logicaIntervencaoId));
    },
    lancamentos() {
      return this.$store.getters['lancamento/byIndicadorId'](parseInt(this.$route.params.indicadorId));
    },
    nivel() {
      return this.$store.getters["enums/nivel"][this.indicadorSelecionado.logicaIntervencao.nivel]
    },
    routeNameIndicador() {
      if (this.indicadorSelecionado) {
        return 'Indicador' + this.nivel.routeName
      }
      return ''      
    },
  },
  watch: {
    indicadores(){
      if(this.indicadores.length) {
        this.indicadorSelecionado = this.indicadores.find(indicador => indicador.id === parseInt(this.$route.params.indicadorId));
        //this.indicadorSelecionado = this.$store.getters["indicador/byId"](parseInt(this.$route.params.indicadorId))
      }
    },  
  },
  methods: {
    ...mapActions("indicador", ["fetchIndicadores"]),

    adicionarSubindicador() {
      if(this.subindicadorId) {
        const payload = { 'logicaIntervencaoId': this.logicaIntervencao.id, 'indicadorPaiId': this.indicadorSelecionado.id, 'indicadorFilhoId': this.subindicadorId }
        this.$store.dispatch("indicador/adicionarSubindicador", payload).then(() => {
          this.subindicadorId = null
        })
      }
    },

    removerSubindicador(item) {
      const payload = { 'logicaIntervencaoId': this.logicaIntervencao.id, 'indicadorPaiId': this.indicadorSelecionado.id, 'indicadorFilhoId': item.id }
      this.$store.dispatch("indicador/removerSubindicador", payload).then(() => {
        this.subindicadorId = null
      })
    },

    excluir() {
      this.$refs.confirm
        .open(
          "Excluir Indicador",
          this.indicadorSelecionado.posicaoFormatada + " " +this.indicadorSelecionado.titulo,
          "Você tem certeza?",
          {}
        )
        .then((confirm) => {
          if (confirm) {
            this.$store.dispatch("indicador/deleteIndicador", this.indicadorSelecionado.id).then(() => {
              this.$router.go(-1)
            })
          }
        });
    },

    reouterPush() {
      this.$router.push({ name: this.routeNameIndicador, params: { logicaIntervencaoId: this.indicadorSelecionado.logicaIntervencao.id, indicadorId: this.indicadorSelecionado.id } })
    }

  },
  created() {
    this.fetchIndicadores(this.$route.params.logicaIntervencaoId).then(() => {
      this.asyncDataStatus_fetched();
    });    
  },
};
</script>

<style src="./IndicadorGerenciamento.scss" lang="scss"/>
